import React, { useRef, useEffect, useState, useCallback } from "react";
import {
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Typography,
  Container,
  Stack,
  Grid,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Certificate1 from "../../../assets/Images/Certificate1.png";
import Certificate2 from "../../../assets/Images/Certificate2.png";
import ImageViewer from "react-simple-image-viewer";
const UserCertifications = ({ currentValue, certificates }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  useEffect(() => {
    if (currentValue == "certificates") {
      certifications.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [currentValue]);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const certifications = useRef();

  return (
    <Container>
      <Stack>
        <Typography
          variant="h6"
          gutterBottom
          component="div"
          ref={certifications}
        >
          Certifications
        </Typography>
        <Grid container rowSpacing={3}>
          {certificates.map((item, index) => (
            <Grid item sm={3}>
              <img
                src={item}
                style={{
                  height: "200px",
                  width: "200px",
                  objectFit: "cover",
                  cursor: "pointer",
                }}
                alt="Banner Person"
                onClick={() => openImageViewer(index)}
              />
            </Grid>
          ))}
        </Grid>
        {isViewerOpen && (
          <ImageViewer
            src={certificates}
            currentIndex={currentImage}
            onClose={closeImageViewer}
            disableScroll={true}
            backgroundStyle={{
              backgroundColor: "rgba(0,0,0,0.9)",
            }}
            closeOnClickOutside={true}
          />
        )}
        {/* <ImageList
          sx={{ width: 500, height: 220 }}
          style={{ overflow: "hidden" }}
        >
          {certificates.map((item) => (
            <ImageListItem key={item} className="container">
              <img
                src={`${item}?w=248&fit=crop&auto=format`}
                srcSet={`${item}?w=248&fit=crop&auto=format&dpr=2 2x`}
                loading="lazy"
                className="image-overlay image"
              />
              <div class="middle">
                <div class="">
                  <RemoveRedEyeIcon />
                </div>
              </div>
              <ImageListItemBar title={item.title} position="below" />
            </ImageListItem>
          ))}
        </ImageList> */}
      </Stack>
    </Container>
  );
};

export default UserCertifications;
